import errorConclusionItem from './errorConclusionItem/index.vue';

import preloader from '@/components/preloader/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  mixins: [
    helpers.work_with_date,
  ],
  components: {
    errorConclusionItem,
    preloader,
  },
  data () {
    return {
      errorConclusionType: [
        'VeryGoodTranslateParams',
        'GoodTranslateParams',
        'PoorTranslateParams',
        'VeryPoorTranslateParams',
        'IncorrectTranslateParams',
      ],

      errorConclusions: [],

      reductionColors: {
        'WT': '#F18D03',
        'WM': '#B2CAE6',
        'OM': '#203354',
        'SE': '#8D0C4C',
        'SP': '#F2B134',
        'PE': '#068587',
        'ME': '#D53D13',
        'FE': '#B2B212',
        'LO': '#85898C',
        'CS': '#485B78',
      },

      load: true,
    };
  },
  created () {
    this.getErrorCnclustion();
  },
  methods: {

    /**
         * Get all error conclusions
         */
    getErrorCnclustion () {
      Api.reports
        .getErrorConclusion(this.$route.params.id)
        .then((data) => {
          if (data.status == 200) {
            this.errorConclusions = data.data;
            this.initErrorConclusionList();
            this.$root.$emit('unDisabledButtonSend', false);
          }
          this.load = false;
        });
    },

    /**
         * Add data in error conclusion list
         */
    initErrorConclusionList () {
      const errorCustomer = this.$store.getters.getDataSendCustomer;

      this.errorConclusions.forEach((itemConclusion) => {
        itemConclusion.Checked = false;
        itemConclusion.AllParams = {};

        this.errorConclusionType.forEach((type) => {
          itemConclusion[type].Type = type.toLowerCase();

          itemConclusion.AllParams[type] = itemConclusion[type];

          itemConclusion[type].Checked = false;

          itemConclusion[type].List.forEach((errCheckbox) => {
            if (errCheckbox.Selected) {
              errorCustomer.ErrorConclusionList.push(errCheckbox.ID);
              itemConclusion.Checked = true;
              itemConclusion[type].Checked = true;
            }
          });
        });
      });
      this.$store.dispatch('REPORTS_DATA_CUSTOMER_UPDATE', errorCustomer);
    },
  },
};
